import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { LogsService } from '@ml/tasks/services';
import { TaskLogParams } from '@ml/tasks/types/classes';
import { Observable } from 'rxjs';
import { TaskLog } from '@ml/tasks/types/classes/task-log.class';
import { tap } from 'rxjs/operators';

@Component({
  selector: 'ml-working-logs-confirmation-dialog',
  template: `
    <div class="container">
      <div class="mat-title">{{ data.title | translate | titlecase }}</div>

      <ng-container *ngIf="(logs$ | async) as logs">
        <div class="mat-subheading-2 container__subtitle">
          <span *ngIf="logs.length === 0; else warningMessage">
            {{ data.message | translate | sentancecase }}
          </span>
          <ng-template #warningMessage>
            {{ 'warning-running-logs' | translate | sentancecase }}
          </ng-template>
        </div>
      </ng-container>

      <div
        *ngIf="loading"
        fxLayout
        fxLayoutAlign="center center"
        class="padding-16"
      >
        <mat-spinner diameter="48"></mat-spinner>
      </div>

      <ml-dialog-actions
        [buttonRight]="'confirm'"
        [disable]="loading"
        (clickLeft)="onClose()"
        (clickRight)="onConfirm()"
      ></ml-dialog-actions>
    </div>
  `,
  styleUrls: ['./working-logs-confirmation-dialog.component.scss']
})
export class WorkingLogsConfirmationDialogComponent implements OnInit {
  logs$: Observable<TaskLog[]>;
  loading: boolean;

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: {
      title: string;
      message: string;
      order?: number;
      task?: number;
    },
    private dialogRef: MatDialogRef<WorkingLogsConfirmationDialogComponent>,
    private logsService: LogsService
  ) {}

  ngOnInit() {
    const params = this.getQueryParams();
    this.loading = true;
    this.logs$ = this.logsService
      .list(params)
      .pipe(tap(() => (this.loading = false)));
  }

  onClose() {
    this.dialogRef.close();
  }

  onConfirm() {
    this.dialogRef.close(true);
  }

  private getQueryParams(): TaskLogParams {
    const params = new TaskLogParams();
    params.in_progress = 'True';
    if (this.data.order) {
      params.order = this.data.order;
    }
    if (this.data.task) {
      params.task = this.data.task;
    }

    return params;
  }
}
